// shared/ui/CatalogAutocomplete.jsx  (presentacional: select buscable MUI ligado a react-hook-form; opciones por props)
import React from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete, InputAdornment, TextField, createFilterOptions } from '@mui/material';
import { autocompleteFieldSx } from './autocompleteSx.js';

// Con listas grandes (productores) solo se pintan las primeras coincidencias.
const defaultFilterOptions = createFilterOptions({ limit: 100 });
const filterPorTexto = stringify => createFilterOptions({ limit: 100, stringify });

const renderOpcion = (props, option, uppercase, secondary) => {
  const detalle = secondary(option);
  return (
    <li {...props} key={option.id}>
      <div style={{ minWidth: 0 }}>
        <div>{uppercase ? option.nombre.toUpperCase() : option.nombre}</div>
        {detalle && <div style={{ fontSize: 12, color: '#6c757d' }}>{detalle}</div>}
      </div>
    </li>
  );
};

// Opcionales: `placeholder`, `startIcon` (clase fa-*), `error` (fieldError de RHF), `uppercase` (etiquetas en mayúsculas),
// `onChangeExternal(id|null)` para que la página reaccione al cambio,
// `stringify(option)` (texto de búsqueda) y `renderOptionSecondary(option)` (segunda línea gris de cada opción).
const CatalogAutocomplete = ({
  name,
  control,
  label,
  options = [],
  loading = false,
  disabled = false,
  placeholder,
  startIcon,
  error,
  uppercase = false,
  onChangeExternal,
  stringify,
  renderOptionSecondary,
}) => {
  const filterOptions = stringify ? filterPorTexto(stringify) : defaultFilterOptions;
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, onBlur, value } }) => (
        <Autocomplete
          style={{ marginTop: 3 }}
          options={options}
          loading={loading}
          disabled={disabled}
          filterOptions={filterOptions}
          renderOption={
            renderOptionSecondary ? (props, option) => renderOpcion(props, option, uppercase, renderOptionSecondary) : undefined
          }
          getOptionLabel={option => (uppercase ? option.nombre.toUpperCase() : option.nombre)}
          isOptionEqualToValue={(option, selected) => option.id === selected.id}
          value={options.find(option => option.id === value) || null}
          onBlur={onBlur}
          onChange={(event, option) => {
            const next = option ? option.id : null;
            onChange(next);
            if (onChangeExternal) onChangeExternal(next);
          }}
          noOptionsText="Sin resultados"
          loadingText="Cargando..."
          renderInput={params => (
            <TextField
              {...params}
              label={label}
              placeholder={placeholder}
              error={!!error}
              sx={autocompleteFieldSx}
              helperText={error ? error.message : undefined}
              InputLabelProps={{
                ...params.InputLabelProps,
                shrink: !!(placeholder || startIcon) || undefined,
              }}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <>
                    {startIcon && (
                      <InputAdornment position="start">
                        <i className={`fa ${startIcon}`} />
                      </InputAdornment>
                    )}
                    {params.InputProps.startAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      )}
    />
  );
};

export default CatalogAutocomplete;
